module.exports = __webpack_public_path__ + "static/003_Room-6a76abdfbb781a09c9995582778d2dbe.jpg";